import actionTypes from "../actions/actionTypes";
import { produce } from "immer";
import panesDefaultState from "../panes.js";

const panesReducer = (state = panesDefaultState, action) => {
    switch (action.type) {
        case actionTypes.SPLITPANES_PERSIST:
        case actionTypes.SPLITPANES_SET:
            return produce(state, (draft) => {
                if (draft[action.payload.view] == null)
                    draft[action.payload.view] = {};
                draft[action.payload.view][action.payload.name] =
                    action.payload.dimensions;
            });
        /* istanbul ignore next */
        case actionTypes.PERSIST_PURGE:
            return panesDefaultState;
        default:
            return state;
    }
};

export default panesReducer;

export const panesViewSelector = (state: Object, viewName: string) =>
    state.panes[viewName];
